module.exports = __webpack_public_path__ + "img/05.0f3be918.jpg";